import apiClient from "../server"

export const fetchMusicGenres = async () => {
    try {
        const response = await apiClient.get('params/music-types/all?pagination=false&isEnabled=true');
        return response.data;
    } catch (error) {
        console.error('Error fetching music genres:', error);
        throw new Error('error getting music genres');
    }
}

export const GetAllMusicGenres=async (pagination=true,page,limit,isEnabled)=>{
    try{
        let url=`params/music-types/all?pagination=${pagination}&limit=${limit}&page=${page}`;
        if(isEnabled==true || isEnabled==false){
            url=url+`&isEnabled=${isEnabled}`
        }
        const response=await apiClient.get(url);
        return response.data;
    }catch{
        throw new Error('error getting music genres');
    }
}

export const GetMusicGenreById=async(id)=>{
    try{
        const response=await apiClient.get(`params/music-types/get/${id}`)
        return response.data;
    }catch{
        throw new Error('error getting music genres');
    }
}


export const LinkProfile=async(MusicGenreID,listIdProfiles) => {
    try{
        const response = await apiClient.patch(`params/music-types/link-profiles/${MusicGenreID}`, {profiles:listIdProfiles});
        return response.data;
    }catch{
        throw new Error('error linking profile to music genre');
    }
}

export const updateMusicGenre = async(musicGenreId,updatedMusicGenre)=>{
    try{
        const response = await apiClient.patch(`params/music-types/update/${musicGenreId}`, updatedMusicGenre);
        return response.data;
    }catch{
        throw new Error('error updating music genre');
    }
}

export const LinkProfileToSubSection = async (subSectionId, profileId) => {
    try {
      const response = await apiClient.patch(
        `params/subSections/link-profiles/${subSectionId}`,
        { profiles:profileId }
      );
      return response.data;
    } catch (error) {
      throw new Error('Error linking profile to SubSection');
    }
  };